import {
  createExternalRouteRef,
  createRouteRef,
} from '@backstage/core-plugin-api';

export const rootRoute = createRouteRef({
  id: 'ai-catalog',
});

export const registerComponentRouteRef = createExternalRouteRef({
  id: 'register-component',
  optional: true,
  defaultTarget: 'catalog-import.importPage',
});
